import { useSelector } from 'react-redux';

export const usePluginsEnabled = (): boolean => {
  return useSelector(
    (state: any) =>
      !!state?.authentication?.chosenBusiness?.has_active_subscription &&
      state.authentication.pluginApps?.length > 0 &&
      !state.authentication.showBlocker
  );
};
